import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";

import { UsageLimitsFAQ } from "./components";

const ContentContainer = styled.div`
  max-width: calc(var(--global-content-width) + 120px);
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
  padding-top: calc(
    var(--global-spacing-navbar-height) + var(--global-spacing-l)
  );
  padding-left: var(--global-spacing-l);
  margin-left: auto;
  margin-right: auto;
`;

const Container = styled.main`
  background: var(--indigo-gradient-245);
  color: var(--global-light-gray);
  & a {
    color: var(--global-light-gray);
    text-decoration: underline;
    :hover {
      color: var(--global-light-gray);
    }
  }
`;

const Title = styled.header`
  text-align: center;
  font-size: 40px;
  margin-bottom: 20px;
`;

const SemgrepInfo = styled.div`
  padding: 20px;
  margin-bottom: 32px;
`;

const Text = styled.div`
  font-size: var(--global-font-size-s);
  margin: 8px;
  padding: 2.4px;
`;

const Bullet = styled.li`
  margin-bottom: var(--global-spacing-m);
`;

const Subheader = styled.div`
  font-size: var(--global-font-size-m);
  line-height: 1.8;
  margin-bottom: 16px;
`;

export const UsageLimitsScreen: React.FC<{}> = () => {
  return (
    <>
      <Helmet>
        <title>Usage Limits for Community Tier</title>
      </Helmet>
      <Container>
        <ContentContainer>
          <Title>Usage Limits for Community Tier</Title>
          <SemgrepInfo>
            <Text>
              <p>
                Effective August 1st, 2022, we're introducing a monthly usage
                limit for Semgrep App's Community tier. Semgrep App Community
                tier organizations will be limited to 20 developers each month.
              </p>
              <p>
                <strong>Here's what you need to know:</strong>
                <ul>
                  <Bullet>
                    These updates do not affect Team or Enterprise tier
                    organizations
                  </Bullet>
                  <Bullet>
                    If you're an existing user with questions, or concerns,
                    please{" "}
                    <b>
                      {/* <MailClick
                            mailto="mailto:support@r2c.dev"
                            text="talk to us"
                          /> */}
                      <a href="mailto:support@r2c.dev">talk to us</a>
                    </b>
                  </Bullet>
                  <Bullet>
                    We love startups, OSS projects, and students! If this
                    describes you, please{" "}
                    <b>
                      <a href="/contact-us?utm_source=website&utm_medium=app&utm_id=0x14&utm_campaign=pricingfaq">
                        contact us
                      </a>
                    </b>{" "}
                    for special pricing
                  </Bullet>
                </ul>
              </p>
              <hr
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  borderColor: "#aaaaaa",
                }}
              />
            </Text>
            <Subheader>
              <strong>Frequently Asked Questions</strong>
            </Subheader>
            <UsageLimitsFAQ />
            <hr
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                borderColor: "#aaaaaa",
              }}
            />
            <Subheader>
              <strong>Startups and OSS Projects</strong>
            </Subheader>
            <p>
              We love startups! We understand how difficult it might be to
              balance being forward-thinking about security and shifting left
              while managing budgets. If you are a startup under 100 employees,
              please{" "}
              <b>
                <a href="/contact-us?utm_source=website&utm_medium=app&utm_id=0x14&utm_campaign=pricingfaq">
                  contact us
                </a>
              </b>{" "}
              for special pricing. <br></br> <br></br>
              Folks using Semgrep for OSS projects, please chat with us too! We
              want to ensure Semgrep can continue to scan and secure your
              projects. <br></br> <br></br>
            </p>
          </SemgrepInfo>
        </ContentContainer>
      </Container>
    </>
  );
};
